export default {
  currentTool: null,
  query: null
}
